module.exports = __webpack_public_path__ + "img/924c29b.png";